import api from './index'
import type { ApiResponse, Project } from '@/types'

export const getProjects = async (): Promise<ApiResponse<{ projects: Project[] }>> => {
  const response = await api.get('/projects')
  return response.data
}

export const getProject = async (projectKey: string): Promise<ApiResponse<{ project: Project }>> => {
  const response = await api.get(`/projects/${projectKey}`)
  return response.data
}

export const createProject = async (projectData: {
  name: string
  key: string
  description?: string
}): Promise<ApiResponse<{ project: Project }>> => {
  const response = await api.post('/projects', projectData)
  return response.data
}

export const updateProject = async (
  projectId: string,
  updateData: Partial<Pick<Project, 'name' | 'description' | 'trashRetentionDays' | 'icon' | 'archived' | 'allowPublicView'>>
): Promise<Project> => {
  const response = await api.put(`/projects/${projectId}`, updateData)
  // API 回傳格式: { success: true, data: { project: {...} } }
  return response.data.data.project
}

export const deleteProject = async (projectId: string): Promise<ApiResponse> => {
  const response = await api.delete(`/projects/${projectId}`)
  return response.data
}

export const addProjectMember = async (
  projectId: string,
  userId: string
): Promise<ApiResponse> => {
  const response = await api.post(`/projects/${projectId}/members`, { userId })
  return response.data
}

export const removeProjectMember = async (
  projectId: string,
  userId: string
): Promise<ApiResponse> => {
  const response = await api.delete(`/projects/${projectId}/members/${userId}`)
  return response.data
}